export enum OrderShipmentMethodKind {
	Unspecified = 'Unspecified',
	Courier = 'Courier',
	Parcel = 'Parcel',
	PickupPoint = 'PickupPoint',
	Locker = 'Locker',
	Personal = 'Personal',
	Custom = 'Custom',
}